<template>
<div class="row full-width full-height"
  oncontextmenu="return false"
  @dragenter="listen__x__ondragenter"
  @dragleave="listen__x__ondragleave"
  @dragover="listen__x__ondragover"
  @drop="listen__x__ondrop"
  >
  <div class="full-height">
    <sample-image-list
      :images="sampleImages"
      @jobstart="showLayer"
      @joberror="(param) => listen__x__onfileerror(param)"
      @jobdone="(file) => preprocessingFile(file)"
    />
  </div>

  <div class="column col full-width full-height" style="padding:10px 30px 25px 30px;">
    <div style="flex:0 0 40px">
      <div class="row" style="padding-bottom: 6px;">
        <div class="row text-h6">
          {{title}}
          <q-btn dense flat icon="help_outline" @click="state.dialogHelp = true" size="xs" style="margin:3px 0px 0px 3px;" v-show="isDev"/>
        </div>
        <q-space />
        <div class="row text-caption" style="align-items:center">
          <health-check-widget
            ref="health-check"
            :functionCheck="healthCheckFunction"
            :recognizeName="recognizeName"
          />
        </div>
      </div>
    </div>


    <div style="flex:0 0 15px;" />

    <div class="column col bg-white shadow-1 full-width">
      <div class="bg-primary" style="padding:10px 10px;">
        <q-file dark color="white" ref="file" :label=fileLabel v-model="compositionFileData.files" dense accept="image/*,.pdf" @input="preprocessingFile" :disable="checkPermission == false">
          <template v-slot:prepend>
            <q-icon name="attach_file" />
          </template>
        </q-file>
      </div>
      <q-separator />
      <q-toolbar>
        <q-btn-group class="image-tool-btn-group" unelevated dense>
          <q-btn unelevated color="primary" icon="fit_screen" label="창에 맞춤" :disable="frameData1._empty == true" dense no-caps @click="$refs['image-view1'].fitToWindow()" style="padding:0px 5px;" />
          <q-separator vertical />
          <q-btn unelevated color="primary" icon="compare" label="이미지 수정" :disable="frameData1._empty == true" dense no-caps @click="$refs['image-processing-dialog'].open(frameData0)" style="padding:0px 5px;" />
          <q-separator vertical />
          <q-btn unelevated color="primary" :icon="state.withOcr ? 'check_box' : 'check_box_outline_blank'" label="OCR결과 표시" dense no-caps @click="state.withOcr = !state.withOcr" style="padding:0px 5px;" />
          <q-separator vertical />
          <q-btn unelevated color="primary" icon="file_download" label="인식결과 다운로드" :disable="frameData1._empty == true" dense no-caps @click="listen__result__download" style="padding:0px 5px;" />
          <q-separator class="menu2" vertical />
          <q-btn class="menu2" flat :ripple="false" dense no-caps style="padding:0px 5px;color:white;border:1px solid #027BE3">          
            <q-btn-group class="color-tool-btn-group" unelevated dense>
              <q-btn unelevated color="primary" :icon="state.colorByCell ? 'check_box_outline_blank' : 'check_box'" label="표" dense no-caps @click="listen__btn_color_cell__onclick" style="padding:0px 5px;font-size:11px;" />
              <q-separator vertical />
              <q-btn unelevated color="primary" :icon="state.colorByCell ? 'check_box' : 'check_box_outline_blank'" label="셀" dense no-caps @click="listen__btn_color_cell__onclick" style="padding:0px 5px;font-size:11px;" />
            </q-btn-group>
            <span style="color:black;font-size:12px;margin-left:5px;">단위로 표시</span>
            <span style="color:black;font-size:12px;margin-left:20px;margin-right:10px;">투명도</span>
            <div style="width:100px;margin-right:8px;">
              <q-slider dense :value="state.opacity" @change="val => { state.opacity = val }" color="black" :min="0.0" :step="0.05" :max="1.0" label />
            </div>
          </q-btn>
        </q-btn-group>
        <q-space />
        <q-separator vertical />
        <div class="btn-structure-analysis" @click="state.TableViewerWidget.show = !state.TableViewerWidget.show">
          <q-icon v-if="state.TableViewerWidget.show == false" name="chevron_left" size="sm" />
          <q-icon v-else name="chevron_right" size="sm" />
          <span class="noselect" style="margin-bottom:1px;">표 구조 분석</span>
        </div>
      </q-toolbar>
      <q-separator />
      <div class="row col full-height full-width">
        <div class="row col full-height full-width">
          <image-view
            ref="image-view1"
            :frame-data="frameData1"
            :pred="pred"
            class="col full-height full-width"
            :passive="false"
            :initial-tool-option="state.currentFrameToolOption"
            :messages-upload=messagesUpload
            @onstatechange="listen__image_view__onstatechange"
          />
        </div>
        <q-separator vertical />
        <table-viewer-widget v-if="state.TableViewerWidget.show" class="col full-width" style="max-width:700px;" :tableHtmls="tableHtmls" />
      </div>
    </div>
  </div>

  <q-dialog v-model="state.dialogHelp">
    <q-card>
      <q-card-section>
        <div class="text-h6">{{title}}</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        표 문서 이미지를 입력 받아 표 영역을 찾고 표를 셀 단위로 분해한다.<br />
        문서 이미지<i style="color:gray">(A4, 좁게 또는 넓게)</i> 에 최적화 되어 있으며 문서 영역을 Crop하여 입력하여야 한다. <br />
        <div v-if="params == 1">
          구분선이 있는 Cell만을 분해 한다. <i>(외곽선의 경우만 선이 없더라도 추정)</i>
        </div>
        <div v-else>
          <b style="color:red">노이즈가 없는 이미지<i>(born-digital)</i></b>에서 잘 동작 한다. <br />
          구분선이 없더라도 Cell 영역을 추정하여 모든 Cell을 분해 한다.
        </div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;Project Page</div>
        <a href="https://confluence.selvasai.com:8443/pages/viewpage.action?pageId=181079917">https://confluence.selvasai.com:8443/pages/viewpage.action?pageId=181079917</a>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 관리 담당</div>
        Johan
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 주소</div>
        {{getAddress()}}
      </q-card-section>

      <q-card-section v-if="params == 1" class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;ML model</div>
        <ul style="margin:0">
          <li style="word-break: break-all;"><b>table recognizer:</b>\\fs\영상지능팀\ocr_selvy-table\resource\model\m11_r3__ml.pb <i style="color:red">(33.8 MB)</i></li>
          <li style="word-break: break-all;"><b>text detector:</b>\\fs\영상지능팀\ocr_selvy-ocr\resource\model\text_detector\jijo\run12.pb <i style="color:red">(7.21 MB)</i></li>
          <li style="word-break: break-all;"><b>text recognizer:</b>\\fs\영상지능팀\ocr_selvy-ocr\resource\model\text_recognizer\SelvyOCR\run13.__ma.pb <i style="color:red">(8.00 MB)</i></li>
        </ul>
      </q-card-section>
      <q-card-section v-else class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;ML model</div>
        <ul style="margin:0">
          <li style="word-break: break-all;"><b>table detector:</b>\\fs\영상지능팀\ocr_selvy-table\resource\model\tatr\detection\e2e.pb <i style="color:red">(110 MB)</i></li>
          <li style="word-break: break-all;"><b>table recognizer:</b>\\fs\영상지능팀\ocr_selvy-table\resource\model\tatr\recognition\e2e.pb <i style="color:red">(110 MB)</i></li>
          <li style="word-break: break-all;"><b>text detector:</b>\\fs\영상지능팀\ocr_selvy-ocr\resource\model\text_detector\jijo\run12.pb <i style="color:red">(7.21 MB)</i></li>
          <li style="word-break: break-all;"><b>text recognizer:</b>\\fs\영상지능팀\ocr_selvy-ocr\resource\model\text_recognizer\SelvyOCR\run13.__ma.pb <i style="color:red">(8.00 MB)</i></li>
        </ul>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="확인" color="primary" v-close-popup />
      </q-card-actions>
    </q-card>
  </q-dialog>

  <q-inner-loading :showing="state.loadingLayer.show">
    <q-spinner-facebook
        color="primary"
        size="2em"
      />
    {{ state.loadingLayer.message }}
  </q-inner-loading>

  <q-inner-loading :showing="compositionDropData.counterDrag > 0">
    <div class="text-h3">드롭하세요.</div>
  </q-inner-loading>

  <image-processing-dialog ref="image-processing-dialog"
    @done="listen__ip_dialog__done"
  />
</div>
</template>


<script>
import compositionDrop from '@/composition/drop.js'
import compositionFile from '@/composition/file.js'

import MixinLayer from '@/mixins/layer.js'

import ImageProcessingDialog from '@/components/ImageProcessingDialog.vue'
import SampleImageList from '@/components/SampleImageList2.vue'
import ImageView from '@/projects/document/components/table_view/ImageView.vue'
import HealthCheckWidget from '@/components/healthCheckWidget.vue'
import TableViewerWidget from '@/components/TableViewerWidget'

import PARSE from '@/js/parse.js'
import MISC from '@/js/miscellaneous.js'
import DocumentOCR from '@/js/document_ocr.js'
import ETC from '@/js/etc.js'
import UserJS from '@/js/user.js'

import {getCurrentInstance} from '@vue/composition-api'

export default {
  setup () {
    const vm = getCurrentInstance()
    if (null == vm ) {
      return {}
    }
    const {compositionFileData, preprocessingImageFile} = compositionFile(vm)
    function preprocessingFile(data) {
      const file = data instanceof File ? data : data.file
      return preprocessingImageFile(file, vm.proxy.listen__x__onfilechange, vm.proxy.listen__x__onfileerror)
    }
    const {compositionDropData, listen__x__ondragenter, listen__x__ondragleave, listen__x__ondragover, listen__x__ondrop} = compositionDrop(preprocessingFile)
    return {
      compositionDropData,
      listen__x__ondragenter,
      listen__x__ondragleave,
      listen__x__ondragover,
      listen__x__ondrop,
      compositionDrop,
      compositionFileData,
      preprocessingFile
    }
  },
  mixins: [MixinLayer],
  props: ['params'],
  data: function () {
    const Vue = this
    return {
      state: {
        dialogHelp: false,
        withOcr: true,
        opacity: 0.5,
        colorByCell: true,
        fitToWindow: false,
        tab: 'text',
        currentFrameState: {
          coord: {
            x: 0,
            y: 0
          },
          zoom: undefined,
          voi: {
            windowCenter: 127,
            windowWidth: 256
          }
        },
        currentFrameToolOption: { mouseButtonMask: 2, lineWidth: 2},
        TableViewerWidget: {
          show: true
        }
      },
      sampleImages1: [
        {
          name: 'type3_6',
          url: 'https://live.staticflickr.com/65535/51931223646_1abafcdc3d_k_d.jpg'
        },
        {
          name: 'test (10)',
          url: 'https://live.staticflickr.com/65535/51931840270_b63db470f1_k_d.jpg'
        },
        {
          name: 'IMG_5505_mask',
          url: 'https://live.staticflickr.com/65535/51931819680_c3ee3cdd00_k_d.jpg'
        },
        {
          name: 'type5_9',
          url: 'https://live.staticflickr.com/65535/51930241222_2c8d8168d5_k_d.jpg'
        },
        {
          name: '5350148-2003-0002-0204',
          url: 'https://live.staticflickr.com/65535/51931223636_3227d4dcd8_k_d.jpg'
        },
        {
          name: 'amount of income3',
          url: 'https://live.staticflickr.com/65535/51931840200_bd2c429e97_k_d.jpg'
        },
        {
          name: 'health insurance2',
          url: 'https://live.staticflickr.com/65535/51931223611_f315b713b9_k_d.jpg'
        },
        {
          name: '건강,장기요양보험료 납부확인서',
          url: `${process.env.VUE_APP_URL}/api/image/4ba838f9-aaf2-4fb0-9fb0-84464618853e.png`
        },
        {
          name: '외래 진료비 세부산정내역',
          url: `${process.env.VUE_APP_URL}/api/image/551b7238-9f4b-4b23-815a-10ee879b9972.jpg`
        },
        {
          name: '진료비 세부산정내역',
          url: `${process.env.VUE_APP_URL}/api/image/dd7545d3-8e0c-4b89-8ecf-1a59e0e47d45.jpg`
        }
      ],
      sampleImages2: [
        {
          name: 'paper 1',
          url: `${process.env.VUE_APP_URL}/api/image/1764df04-9d96-48a1-9878-b6c18bb69952.jpg`
        },
        {
          name: 'paper 2',
          url: `${process.env.VUE_APP_URL}/api/image/264e40af-39e2-4c79-9bfc-03519182c50b.png`
        },
        {
          name: 'paper 3',
          url: `${process.env.VUE_APP_URL}/api/image/4912c8b3-52eb-4612-b69e-92476172e4a7.jpg`
        },
        {
          name: 'paper 4',
          url: `${process.env.VUE_APP_URL}/api/image/4be5cef9-c907-4e67-b273-a8b0241caac7.png`
        },
        {
          name: 'paper 5',
          url: `${process.env.VUE_APP_URL}/api/image/4dbfa91c-667c-47af-919b-b5d7d0a7e8b5.png`
        },
        {
          name: 'paper 6',
          url: `${process.env.VUE_APP_URL}/api/image/6289a038-69a2-47a3-b427-22a358f42c48.png`
        },
        {
          name: 'paper 7',
          url: `${process.env.VUE_APP_URL}/api/image/b4251480-8d47-492a-a8a8-d29887d6465c.jpg`
        },
        {
          name: 'paper 8',
          url: `${process.env.VUE_APP_URL}/api/image/d3fd9f9f-fa47-4ef3-bf92-1f35e7502e63.png`
        },
        {
          name: 'paper 9',
          url: `${process.env.VUE_APP_URL}/api/image/d527d223-5bef-4b9b-a0ec-56172b73efff.jpg`
        },
        {
          name: 'paper 10',
          url: `${process.env.VUE_APP_URL}/api/image/f181cf80-2a93-44e1-a1f8-d09e4492140e.png`
        }
      ],
      frameData1: {
        _uid: MISC.getUuid4(),
        _empty: true
      },
      pred: [],
      excelBase64: '',
      tableHtmls: [],
      title: Vue.params == 1 ? "표 인식 / method1" : "표 인식 / method2",
      recognizeName: "table"
    }
  },
  components: {
    ImageProcessingDialog,
    SampleImageList,
    ImageView,
    HealthCheckWidget,
    TableViewerWidget
  },
  methods: {
    listen__x__onfilechange: function (file, options) {
      const Vue = this
      
      const keepFrameData0 = (options != undefined && options.keepFrameData0 == true) ? true : false
      Vue.clearData(keepFrameData0)
      Vue.showLayer('이미지를 읽는 중...');
      
      MISC.doubleRaf(async () => {
        let image;
        
        let tokens = file.name.split('.');
        let ext = tokens[tokens.length - 1].toLowerCase();
        try {
          image = await PARSE.parseImage(file, ext);
        } catch (err) {
          console.log(err)
          Vue.listen__x__onfileerror({color: 'purple', message: '이미지 읽기에 실패하였습니다'})
          return
        }
        let cornerstoneImage = await Vue.$cornerstone.createCornerstoneImageRgba(undefined, image.pixelData, image.width, image.height);

        Vue.showLayer('인식 중...');
        let ret = {};
        let processingTime
        try {
          const begin = new Date();
          ret = await Vue.recognizeTable(file, Vue.state.withOcr);
          let ret_tables = []
          let ret_text_blocks = []
          if (ret.data != undefined) {
            if (ret.data.result != undefined) {
              if (ret.data.result.tables != undefined)
                ret_tables = ret.data.result.tables
            }
            if (ret.data.result != undefined) {
              if (ret.data.result.text_blocks != undefined)
                ret_text_blocks = ret.data.result.text_blocks
            }
          }
          
          processingTime = (new Date() - begin) / 1000
          
          let pred = []
          for (let nt in ret_tables) {
            let table = ret_tables[nt]
            const color_table = MISC.convertRgbToHex(Vue.getRandomInt(50, 256), Vue.getRandomInt(50, 256), Vue.getRandomInt(50, 256))
            for (let nc in table.cells) {
              let cell = table.cells[nc]
              let box_type = 'cell'
              let color
              if (Vue.state.colorByCell == true)
                color = MISC.convertRgbToHex(Vue.getRandomInt(50, 256), Vue.getRandomInt(50, 256), Vue.getRandomInt(50, 256))
              else
                color = color_table
              
              let text = ''
              if (table.structure == true) {
                if (cell.value.length > 0)
                  text = `${cell.value}\n`
                text += `row: ${cell.start_row}~${cell.end_row}\ncol: ${cell.start_col}~${cell.end_col}`
                box_type = 'table'
              }
              else {
                text = cell.value
              }

              const shrink_dist = 1
              pred.push({
                id: nt, text, box_type,
                active: true,
                highlight: false,
                color: color,
                opacity: MISC.toHex(parseInt(Vue.state.opacity * 255)),
                points: [
                  {x: cell.pts[0][0] + shrink_dist, y: cell.pts[0][1] + shrink_dist},
                  {x: cell.pts[1][0] - shrink_dist, y: cell.pts[1][1] + shrink_dist},
                  {x: cell.pts[2][0] - shrink_dist, y: cell.pts[2][1] - shrink_dist},
                  {x: cell.pts[3][0] + shrink_dist, y: cell.pts[3][1] - shrink_dist},
                ]
              });
            }
          }

          for (let nt in ret_text_blocks) {
            let text_block = ret_text_blocks[nt]
            // const color = MISC.convertRgbToHex(Vue.getRandomInt(50, 256), Vue.getRandomInt(50, 256), Vue.getRandomInt(50, 256))
            const color = MISC.convertRgbToHex(255, 0, 0)
            
            let text = ''
            if (text_block.value.length > 0)
              text = `${text_block.value}\n`

            const shrink_dist = 1
            let box_type = 'text'
            pred.push({
              id: nt+1000, text, box_type,
              active: true,
              highlight: false,
              color: color,
              opacity: MISC.toHex(parseInt(Vue.state.opacity * 255)),
              points: [
                {x: text_block.pts[0][0] + shrink_dist, y: text_block.pts[0][1] + shrink_dist},
                {x: text_block.pts[1][0] - shrink_dist, y: text_block.pts[1][1] + shrink_dist},
                {x: text_block.pts[2][0] - shrink_dist, y: text_block.pts[2][1] - shrink_dist},
                {x: text_block.pts[3][0] + shrink_dist, y: text_block.pts[3][1] - shrink_dist},
              ]
            });
          }

          ret.pred = pred
        } catch (err) {
          console.log(err)
          Vue.listen__x__onfileerror({color: 'red', message: err})
          return
        }
        if (keepFrameData0 == true) {
          Vue.frameData1 = {
            id: MISC.getUuid4(),
            name: file.name,
            cornerstoneImage,
            _empty: false
          }
        } else {
          Vue.frameData0 = {
            id: MISC.getUuid4(),
            name: file.name,
            cornerstoneImage,
            _empty: false
          }
          Vue.frameData1 = Vue.frameData0
        }
        Vue.pred = ret.pred
        Vue.excelBase64 = ret.data.excelBase64
        Vue.tableHtmls = Vue.makeTableHtmls(ret.data.result)
        ret.data['processingTime'] = processingTime
        Vue.hidingLayer()
      });
    },
    listen__x__onfileerror: function (param) {
      const Vue = this

      Vue.compositionFileData.files = []
      Vue.clearData()
      Vue.hidingLayer()

      let color = param.color
      if (color == undefined)
        color = 'black'

      Vue.$q.notify({
        message: param.message,
        icon: 'announcement',
        color
      })
    },
    listen__image_view__onstatechange: function (data) {
      if (data.coord != undefined)
        this.state.currentFrameState.coord = {x: data.coord.x, y: data.coord.y}
      if (data.zoom != undefined)
        this.state.currentFrameState.zoom = data.zoom
      if (data.voi != undefined)
        this.state.currentFrameState.voi = {windowCenter: data.voi.windowCenter, windowWidth: data.voi.windowWidth}
    },
    listen__btn_color_cell__onclick: function () {
      this.state.colorByCell = !this.state.colorByCell;

      if (this.state.colorByCell == true) {
        for (let row of this.pred) {
          if ("text" == row.box_type) {
            row['color'] = MISC.convertRgbToHex(255, 0, 0);
            continue;
          }
          const color = MISC.convertRgbToHex(this.getRandomInt(50, 256), this.getRandomInt(50, 256), this.getRandomInt(50, 256))
          row['color'] = color
        }
      } else {
        let colors = {}
        for (let row of this.pred) {
          if ("text" == row.box_type) {
            row['color'] = MISC.convertRgbToHex(255, 0, 0);
            continue;
          }
          if (colors[row.id] == undefined)
            colors[row.id] = MISC.convertRgbToHex(this.getRandomInt(50, 256), this.getRandomInt(50, 256), this.getRandomInt(50, 256))
          row['color'] = colors[row.id]
        }
      }
      
      this.$refs['image-view1'].updateTagging()
    },
    listen__ip_dialog__done: async function (data) {
      const Vue = this
      if (Vue.frameData1.id != data.id) {
        Vue.listen__x__onfilechange(
          PARSE.encodeImage(Vue.frameData1.name, data.cornerstoneImage.getPixelData(), data.cornerstoneImage.width, data.cornerstoneImage.height),
          {keepFrameData0: true}
        )
      }
    },
    listen__result__download: function () {
      const Vue = this
      try {
        const name = Vue.compositionFileData.files[0].name
        var link = document.createElement('a');
        link.download = name + "__.xlsx";
        link.href = URL.createObjectURL(
          new Blob([MISC.convertBase64ToBuffer(Vue.excelBase64)], { type: '' })
        );
        link.click();
      } catch (err) {
        Vue.$q.notify({
          message: '인식결과 다운로드에 실패하였습니다.',
          icon: 'announcement',
          color: 'purple'
        })
      }
    },
    clearData: function (keepFrameData0) {
      if (keepFrameData0 == false) {
        this.frameData0 = {
          _uid: MISC.getUuid4(),
          _empty: true
        }
      }
      this.frameData1 = {
        _uid: MISC.getUuid4(),
        _empty: true
      }
      this.pred = []
      this.excelBase64 = ''
    },
    getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min)) + min;
    },
    makeTableHtmls: function (response) {
      let tableHtmls = []

      if (response == undefined || response.tables == undefined)
        return tableHtmls
      
      for (let table of response.tables) {
        if (table.structure == false)
          continue
        
        table.cells.sort((v1, v2) => {
          if (v1.start_row != v2.start_row) {
            if (v1.start_row < v2.start_row)
              return -1
            else
              return 1
          } else {
            if (v1.start_col < v2.start_col)
              return -1
            else
              return 1
          }
        })

        let skip_flag = new Array(table.cells.length).fill(false)
        for (let i1 = 0; i1 < table.cells.length; i1++) {
          const cell1 = table.cells[i1]
          for (let i2 = 0; i2 < table.cells.length; i2++) {
            if (i1 == i2)
              continue
            const cell2 = table.cells[i2]

            if (cell1.start_row >= cell2.start_row && cell1.end_row <= cell2.end_row && cell1.start_col >= cell2.start_col && cell1.end_col <= cell2.end_col)
              skip_flag[i1] = true
          }
        }

        let tableHtml = '<table><tbody><tr>'
        let current_row = 0
        for (let i = 0; i < table.cells.length; i++) {
          if (skip_flag[i])
            continue
          
          const cell = table.cells[i]
          if (current_row != cell.start_row) {
            current_row = cell.start_row
            tableHtml += '</tr><tr>'
          }

          tableHtml += '<td'
          if (cell.end_row - cell.start_row > 1)
            tableHtml = tableHtml + ' Rowspan=' + (cell.end_row - cell.start_row) + ' '
          if (cell.end_col - cell.start_col > 1)
            tableHtml = tableHtml + ' Colspan=' + (cell.end_col - cell.start_col) + ' '
          tableHtml += '>'

          if (cell.value.length > 0) {
            tableHtml = tableHtml + cell.value.replaceAll('\n', '<br/>') + '</td>'
          } else
            tableHtml = tableHtml + '&nbsp;</td>'
        }

        tableHtml += '</tr></tbody></table>'
        tableHtmls.push(tableHtml)
      }

      return tableHtmls
    },
    getAddress: function () {
      const Vue = this
      return Vue.$refs['health-check'] == undefined ? '' : Vue.$refs['health-check'].getAddress()
    }
  },
  computed: {
    checkPermission() {
      const Vue = this
      if (ETC.isDev())
        return true
      if (undefined != Vue.recognizeName)
        return UserJS.checkPermission(Vue.$store.state.user.permission, Vue.recognizeName)
      return true
    },
    isDev() {
      return ETC.isDev()
    },
    messagesUpload() {
      if (this.checkPermission)
        return ['\'샘플 이미지\'를 선택,', '\'파일 업로드...\'를 클릭,', '또는 이미지를 여기로 \'드래그\' 하여', '인식을 시작합니다.']
      return ['\'샘플 이미지\'를 선택 하세요.']
    },
    fileLabel() {
      if (this.checkPermission)
        return '파일 업로드...'
      return '파일 업로드 권한이 없습니다.' 
    },
    cameraLabel() {
      if (this.checkPermission)
        return '카메라 열기'
      return '카메라 권한이 없습니다.' 
    },
    sampleImages: function () {
      const Vue = this
      return Vue.params == 1 ? Vue.sampleImages1 : Vue.sampleImages2
    },
    recognizeTable: function () {
      const Vue = this
      return Vue.params == 2 ? DocumentOCR.recognizeTable2 : DocumentOCR.recognizeTable1
    },
    healthCheckFunction: function () {
      const Vue = this
      return Vue.recognizeTable
    }, 
  },
  watch: {
    "state.opacity": function (opacity) {
      for (let row of this.pred)
        row['opacity'] = MISC.toHex(parseInt(opacity * 255))
      this.$refs['image-view1'].updateTagging()
    }
  },
  async mounted () {
    const Vue = this
    Vue.$refs['health-check'].listen__healthcheck__onclick()
    console.log(this.getAddress())
  }
}
</script>

<style scoped>
.rtab:not(.col) {
  flex: 0 0 400px;
}

@media (max-width: 1000px) {
  .image-tool-btn-group {
    display: none !important;
  }
}

@media (max-width: 1300px) {
  .image-tool-btn-group > .menu2 {
    display: none !important;
  }
}
</style>

<style>
.color-tool-btn-group .q-btn__content > i {
  font-size: 15px;
  margin-right: 3px;
}
.color-tool-btn-group .q-btn__wrapper {
  padding:0 !important;
}
.btn-structure-analysis {
  cursor: pointer;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 7px 0px 0px;
}
.btn-structure-analysis:hover {
  background:#FAFAFA;
}
</style>